export const xControlsState = {
  aiSearchFallback: true,
  fullPredictiveLayer: false,
}
